import * as React from 'react';
import cx from 'clsx';
import sharedStyles from './shared-groups.module.css';
import styles from './addons-group.module.css';

export interface Addon {
  description: string;
  iconLightPath: string;
  iconDarkPath: string;
  isAvailable?: boolean;
}

export interface AddonsGroupProps {
  title: string;
  addons: Addon[];
}

export function AddonsGroup({ title, addons }: AddonsGroupProps): React.ReactNode {
  return (
    <div data-test-addons-group>
      <h3 className={cx('body-prominent', 'mb-8', sharedStyles.title)} data-test-title>
        {title}
      </h3>
      <ul className={sharedStyles.list}>
        {addons.map(({ description, iconLightPath, iconDarkPath, isAvailable = true }, index) => (
          <li
            className={cx(
              sharedStyles['list-item'],
              styles['list-item'],
              !isAvailable && styles['not-available'],
              'mb-8'
            )}
            data-test-addon-description={index}
            key={description}
          >
            <div
              aria-hidden="true"
              className={cx('mr-16', sharedStyles.image, styles.image)}
              style={
                // oxlint-disable-next-line typescript/consistent-type-assertions
                {
                  '--icon-light-path': `url(${iconLightPath})`,
                  '--icon-dark-path': `url(${iconDarkPath})`,
                } as React.CSSProperties
              }
            />
            <span>{description}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
